const backgroundUpdate = (state = false, action)=>{
    if (action.type === "SET_BACKGROUND_UPDATE") {
        state = action.background
    }
    return state;
}

export default backgroundUpdate;